/**
 * Generate a consistent PDF filename following the pattern:
 * <patient-name>-<report-name>-report-<date>-<order-id>.pdf
 * 
 * @param {string} patientName - Patient's full name
 * @param {string} reportName - Type of report (e.g., 'dexa', 'alzheimer', 'vo2max', 'summary', 'strength', 'fatloss', 'blood')
 * @param {string} orderId - Patient's order ID or sukra_order_id
 * @returns {string} Formatted PDF filename
 */
export const generatePDFFilename = (patientName, reportName, orderId) => {
  // Sanitize patient name - remove special characters and replace spaces with hyphens
  const sanitizedName = (patientName || 'patient')
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .trim();

  // Sanitize report name
  const sanitizedReportName = (reportName || 'report')
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, '')
    .trim();

  // Format date as YYYY-MM-DD
  const date = new Date().toISOString().split('T')[0];

  // Sanitize order ID
  const sanitizedOrderId = (orderId || 'unknown')
    .toString()
    .replace(/[^a-z0-9-]/gi, '')
    .trim();

  return `${sanitizedName}-${sanitizedReportName}-report-${date}-${sanitizedOrderId}.pdf`;
};

export default generatePDFFilename;
